<template>
  <v-sheet color="#FBF9F4">
    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <div
        v-if="!loading && items.length"
        class="py-10 py-md-13 py-lg-16 items"
      >
        <v-container class="py-0">
          <TitleWidget v-if="title" class="text-center">
            {{ title }}
          </TitleWidget>

          <div class="mt-10 grid-list">
            <template v-for="(item, keyItems) in items">
              <ProductCard :key="keyItems" v-bind="item" />
            </template>
          </div>
        </v-container>
      </div>
    </transition>

    <v-container v-if="!loading && items.length && divider" class="py-0">
      <v-sheet width="100%" height="3px" color="#EAE3D2"></v-sheet>
    </v-container>
  </v-sheet>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import TitleWidget from "../widgets/TitleWidget.vue";
import ProductCard from "../cards/ProductCard.vue";

export default {
  props: {
    divider: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "",
    },
  },
  components: {
    LoadingWidget,
    TitleWidget,
    ProductCard,
  },
};
</script>

<style lang="scss" scoped>
.grid-list {
  display: grid;
  gap: 62px;
  grid-template-columns: repeat(4, minmax(0, 1fr));

  @media screen and (max-width: 960px) {
    gap: 30px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media screen and (max-width: 600px) {
    gap: 30px 10px;
  }
}
</style>
